import React from 'react';
import { LongRead } from './LongRead';
import { NormalRead } from './NormalRead';

const BlogPost = ({ post, sections }) => {
  if (!post) return null;

  return post.type === 'long' ? (
    <LongRead post={post} anchors={sections} />
  ) : (
    <NormalRead post={post} anchors={sections} />
  );
};

export default BlogPost;